module.exports = __webpack_public_path__ + "static/media/shampoo.3850f815.svg";